import Vue from "vue";
import router from "@/router/index";
import Home from "@/views/templates/hallways/Home.vue";
import SiteMap from "@/views/templates/hallways/SiteMap.vue";
import Login from "@/views/templates/hallways/Login.vue";
import Validation from "@/views/templates/hallways/Validation.vue";
import Error from "@/views/templates/hallways/Error.vue";
import NotSupported from "@/views/templates/hallways/NotSupported.vue";
import AuthError from "@/views/templates/hallways/AuthError.vue";
import Mantainance from "@/views/templates/hallways/Mantainance.vue";
import { mapGetters } from "vuex";
import SurveyCompiled from "@/views/templates/hallways/SurveyCompiled.vue";
export default Vue.extend({
    computed: {
        ...mapGetters('auth', {
            nextRoute: "getNextRoute"
        })
    },
    props: {
        templateName: String,
        customerCode: String,
        templateConfig: {}
    },
    data() {
        return {};
    },
    mounted() {
        router.addRoute({ path: '/:customerCode', name: 'HomeTemplate', component: Home, props: { templateName: this.templateName } });
        router.addRoute({ path: '/:customerCode/open/:codeTag', name: 'Autopilot', component: Home, props: { templateName: this.templateName } });
        router.addRoute({ path: '/:customerCode/mantainance', name: 'Mantainance', component: Mantainance, props: true });
        router.addRoute({ path: '/:customerCode/authError', name: 'AuthError', component: AuthError, props: true });
        router.addRoute({ path: '/:customerCode/notSupported', name: 'NotSupported', component: NotSupported, props: true });
        router.addRoute({ path: '/:customerCode/error', name: 'Error', component: Error, props: true });
        router.addRoute({ path: '/:customerCode/validation', name: 'Validation', component: Validation, props: true });
        router.addRoute({ path: '/:customerCode/login', name: 'Login', component: Login, props: true });
        router.addRoute({ path: '/:customerCode/surveyCompiled', name: 'SurveyCompiled', component: SurveyCompiled, props: true });
        router.addRoute({ path: '/:customerCode/siteMap', name: 'SiteMap', component: SiteMap, props: { templateName: this.templateName } });
        let rotta = { name: 'HomeTemplate' };
        if (this.nextRoute) {
            rotta = { path: this.nextRoute };
            this.$store.dispatch("auth/setNextRoute", undefined);
        }
        router.push(rotta);
    },
    methods: {},
    components: {
        Home,
        SiteMap,
        Login,
        Validation,
        Error,
        NotSupported,
        AuthError,
        Mantainance
    },
});
